export function initLoginSteps({ form, continueBtn, backBtn, emailInput, passwordInput, emailPreview, forgotPasswordLink }) {
  // Click continue (email -> password)
  continueBtn.addEventListener('click', () => {
    if (!emailInput.value) return;
    emailPreview.textContent = `Signing in as ${emailInput.value}`;
    form.classList.remove('step-initial');
    form.classList.add('step-password');
    if (forgotPasswordLink) {
      const url = new URL(forgotPasswordLink.href);
      url.searchParams.set('email', emailInput.value);
      forgotPasswordLink.href = url.toString();
    }
    passwordInput.focus();
  });

  // Click back
  backBtn.addEventListener('click', () => {
    form.classList.remove('step-password');
    form.classList.add('step-initial');
    emailInput.focus();
  });
}
